/**
 * Owner: Masa Bayu
 * File: qxcircle-follow-list-api.ts
 * Date:Time: 2026-09-18 11:11
 * Description: QXCircle followers/following — session viewer handle, no mock id.
 */

import {
  getQxCircleEngine,
  getQxCircleSessionHandle,
} from '../engine/local-runtime';

export type QxCircleFollowListKind = 'followers' | 'following';

export type QxCircleFollowListPerson = {
  authorHandle: string;
  authorName: string;
  followedByLocal: boolean;
};

export type QxCircleFollowListResponse = {
  authorHandle: string;
  authorName: string;
  kind: QxCircleFollowListKind;
  count: number;
  items: QxCircleFollowListPerson[];
  world: 'qxcircle';
  slice: 'follow-list';
};

export async function getQxCircleFollowList(
  authorHandle: string,
  kind: QxCircleFollowListKind,
): Promise<QxCircleFollowListResponse> {
  const engine = getQxCircleEngine();
  const viewer = getQxCircleSessionHandle();
  return kind === 'followers'
    ? engine.listFollowers(authorHandle, viewer)
    : engine.listFollowing(authorHandle, viewer);
}
